import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ParticularsResults from "./particulars";
import { RootState } from "../../store/combineReducer";
import Reports from "./reports";
import SearchByDni from "./searchByDni";
import InfoOffcanvas from '../../components/others/InfoOffCanvas/InfoOffCanvas';
import "./results_page.scss";
import { User, Shield, FileText, ChevronRight } from 'lucide-react';

const PAGE_TABS = [
  { id: "Servicios - Prestaciones", label: "Servicios - Prestaciones", icon: "📊" },
  { id: "Buscar por DNI", label: "Buscar por DNI", icon: "🔍" },
];

const ResultsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams("");
  const roles = useSelector((state: RootState) => state.user.roles);
  const [currentTab, setCurrentTab] = useState(
    searchParams.get("currentTab") || PAGE_TABS[0].id,
  );

  const handleChangeTab = (tab: string) => {
    setCurrentTab(tab);
    setSearchParams({
      currentTab: tab,
    });
  };

  const getCurrentTabInfo = () => {
    return PAGE_TABS.find(tab => tab.id === currentTab) || PAGE_TABS[0];
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case "Servicios - Prestaciones":
        return <Reports />;
      case "Buscar por DNI":
        return <SearchByDni />;
      default:
        return <Reports />;
    }
  };

  // Vista para clientes particulares
  if (roles.includes("PARTICULAR_CLIENT")) {
    return (
      <div className="main-container">
        <div className="atendoo-card">
          {/* Header Section for Particulars */}
          <div className="custom-header">
            <div className="header-top">
              <h6 className="subtitle">Mis Resultados</h6>
              <InfoOffcanvas title="INFORMACIÓN PARA CLIENTES PARTICULARES">
                <div className="particular-info">
                  <div className="info-section">
                    <h4 className="info-title">Acceso a Resultados</h4>
                    <ul className="info-list">
                      <li>Visualiza todos tus estudios médicos realizados</li>
                      <li>Descarga reportes en formato PDF</li>
                      <li>Consulta el historial completo de tus exámenes</li>
                      <li>Accede a los resultados apenas estén disponibles</li>
                    </ul>
                  </div>

                  <div className="info-section">
                    <h4 className="info-title">¿Cómo usar esta sección?</h4>
                    <ul className="info-list">
                      <li>Los resultados se organizan por fecha de realización</li>
                      <li>Puedes filtrar por tipo de estudio o fecha</li>
                      <li>Haz clic en "Descargar" para obtener el PDF completo</li>
                      <li>Si tienes dudas sobre algún resultado, consulta con tu médico</li>
                    </ul>
                  </div>
                </div>
              </InfoOffcanvas>
            </div>

            {/* <div className="particular-banner">
              <div className="banner-gradient"></div>
              <div className="banner-pattern"></div>

              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <div className="banner-icon-container">
                      <div className="banner-icon">
                        <User size={28} strokeWidth={2} />
                      </div>
                      <div className="icon-glow"></div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="banner-content">
                      <h3 className="banner-title mb-1">
                        Panel de Cliente Particular

                      </h3>
                      <p className="banner-subtitle mb-0">
                        Accede a todos tus resultados médicos de forma segura
                      </p>
                    </div>
                  </div>

                  <div className="col-auto d-none d-lg-block">
                    <div className="banner-features">
                      <div className="feature-item">
                        <Shield size={16} />
                        <span>Seguro</span>
                      </div>
                      <div className="feature-item">
                        <FileText size={16} />
                        <span>Resultados</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-auto">
                    <div className="banner-action">
                      <ChevronRight size={20} className="action-arrow" />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            {/* Content for Particulars */}
            <div className="particular-content">
              <ParticularsResults />
            </div>
          </div>


        </div>
      </div>
    );
  }

  // Vista para usuarios corporativos
  return (
    <div className="main-container">
      <div className="atendoo-card">
        {/* Header Section */}
        <div className="custom-header">
          <div className="header-top">
            <h6 className="subtitle">Centro de Resultados</h6>
            <InfoOffcanvas title="INFORMACIÓN SOBRE RESULTADOS">
              <div className="results-info">
                <div className="info-section">
                  <h4 className="info-title">Servicios - Prestaciones</h4>
                  <ul className="info-list">
                    <li>Consulta reportes consolidados por empresa</li>
                    <li>Visualiza estadísticas de aptitudes médicas</li>
                    <li>Descarga reportes en Excel y PDF</li>
                    <li>Filtra resultados por fechas, áreas o tipos de examen</li>
                    <li>Accede a gráficos y métricas de seguimiento</li>
                  </ul>
                </div>

                <div className="info-section">
                  <h4 className="info-title">Buscar por DNI</h4>
                  <ul className="info-list">
                    <li>Búsqueda rápida de resultados por documento</li>
                    <li>Consulta el historial médico de empleados específicos</li>
                    <li>Visualiza el estado actual de aptitudes</li>
                    <li>Accede a exámenes periódicos y de ingreso</li>
                    <li>Descarga certificados médicos individuales</li>
                  </ul>
                </div>

                <div className="info-section">
                  <h4 className="info-title">Permisos y Acceso</h4>
                  <ul className="info-list">
                    <li>Los resultados respetan los permisos de cada rol</li>
                    <li>Solo se muestran datos autorizados para tu nivel de acceso</li>
                    <li>Toda consulta queda registrada por seguridad</li>
                    <li>Los datos están protegidos según normativas vigentes</li>
                  </ul>
                </div>
              </div>
            </InfoOffcanvas>
          </div>
        </div>

        {/* Navigation Tabs */}

        <div className="tabs-container mb-3">
          <nav className="tabs-nav">
            {PAGE_TABS.map((tab, index) => {
              return (
                <button
                  key={tab.id}
                  className={`tab-button ${currentTab === tab.id ? 'active' : ''}`}
                  onClick={() => handleChangeTab(tab.id)}
                >
                  <span className="tab-icon">{tab.icon}</span>
                  <span className="tab-label">{tab.label}</span>
                </button>
              )
            })}
          </nav>
        </div>

        <div className="current-tab-info">
          <div className="tab-indicator">
            <h5 className="section-title">{getCurrentTabInfo().label}</h5>
          </div>
        </div>


        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </div>
  );
};

export default ResultsPage;